
class ProductRecommendations {
  constructor() {
    this.init();
  }

  init() {
    // 初始化 Swiper
    this.initSwiper();
    // 绑定事件
    this.bindEvents();
  }

  initSwiper() {
    const swiperElement = document.querySelector('.product-recommendations-swiper');
    
    if (!swiperElement) return;

    this.swiper = new Swiper('.product-recommendations-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 16,
      navigation: {
        nextEl: '.product-recommendations-next',
        prevEl: '.product-recommendations-prev',
      },
    });
  }

  bindEvents() {
    // 绑定加入购物车按钮
    document.querySelectorAll('.recommendation-card__add-to-cart').forEach((button) => {
      button.addEventListener('click', (e) => {
        e.stopPropagation(); // 阻止事件冒泡到卡片
        this.handleAddToCart(button);
      });
    });

    // 绑定产品卡片点击跳转
    document.querySelectorAll('.recommendation-card').forEach((card) => {
      card.addEventListener('click', (e) => {
        // 如果点击的是加入购物车按钮或其子元素,则不跳转
        if (e.target.closest('.recommendation-card__add-to-cart')) {
          return;
        }
        
        const productUrl = card.dataset.productUrl;
        if (productUrl) {
          window.open(productUrl, '_blank');
        }
      });
    });
  }

  async handleAddToCart(button) {
    const variantId = button.dataset.productId;
    const productTitle = button.dataset.productTitle;
    
    if (!variantId) {
      console.error('Product variant ID not found');
      return;
    }

    // 禁用按钮并显示加载状态
    button.disabled = true;
    const originalText = button.querySelector('span').textContent;
    button.querySelector('span').textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      const data = await response.json();
      
      // 成功添加后的反馈
      button.querySelector('span').textContent = 'Added!';
      
      // 触发购物车更新事件(如果主题有购物车组件监听)
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
        })
      );

      // 2秒后恢复按钮状态
      setTimeout(() => {
        button.disabled = false;
        button.querySelector('span').textContent = originalText;
      }, 2000);

    } catch (error) {
      console.error('Error adding to cart:', error);
      
      // 恢复按钮状态并显示错误
      button.disabled = false;
      button.querySelector('span').textContent = 'Error';
      
      setTimeout(() => {
        button.querySelector('span').textContent = originalText;
      }, 2000);
    }
  }
}

// 初始化
document.addEventListener('DOMContentLoaded', () => {
  new ProductRecommendations();
});
